// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3frYQ","clinicsSelect":"TableHeading_clinicsSelect__2Vr7x"};